import withPage from '@lib/page';
import QuotationPage from '@views/pages/quotation';

export default withPage(QuotationPage);
